import React, { useEffect, useState } from 'react'
import { ButtonBack, ButtonNext, CarouselProvider, Slide, Slider } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'
import './newSwimlane.css'
import { withTheme } from 'theming'
import { isEmpty } from 'lodash'
import useTemplateHook from '../templateHook'
import EditMenu from '../editMenu'
import useAxios from 'axios-hooks'
import AddSection from '../addSection'
import NewContentCardHover from '../../contentCard/newContentCardHover'
import PortraitOwlCard from '../../contentCard/portraitOwlCard'

const VerticalSpotlightCards = ({
  componentData,
  modifyData,
  setModalState,
  isEdit = true,
  onDelete,
  onSwap,
  onCopy,
  theme,
  onAdd,
}) => {
  //   const { data, title, filters, seeMoreVisible, type, theme } = props
  const { data, id, component_key } = componentData
  const [hoverState, setHoverState] = useState('')
  const {
    isBrowser,
    XL_SIZE,
    XXL_SIZE,
    LG_SIZE,
    SM_SIZE,
    CONTENT_FILTER_XAVIER,
    KalingoLeftArrow,
    KalingoRightArrow,
  } = useTemplateHook()
  const [hoverCardIndex, setHoverCardIndex] = useState('')
  const [visibleSlides, setVisibleSlides] = useState(2)
  const [contentData, setContentData] = useState([])
  const [contentMapData, setContentMapData] = useState([])
  const language = localStorage.getItem('language') || 'en'
  const isAoSportsComponent = `${component_key}`.includes('AoSports')

  const [{ data: contentList }, contentListCall] = useAxios(
    {
      url: CONTENT_FILTER_XAVIER,
      method: 'post',
    },
    { manual: true },
  )

  const handleResize = () => {
    if (window.innerWidth >= XXL_SIZE) {
      setVisibleSlides(8)
    } else if (window.innerWidth < XXL_SIZE && window.innerWidth >= XL_SIZE) {
      setVisibleSlides(7)
    } else if (window.innerWidth < XL_SIZE && window.innerWidth >= LG_SIZE) {
      setVisibleSlides(6)
    } else if (window.innerWidth < LG_SIZE && window.innerWidth >= SM_SIZE) {
      setVisibleSlides(5)
    } else {
      setVisibleSlides(2.5)
    }
  }

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const getDynamicFilters = (autoPayload) => {
    let obj = {}

    let ownersObj = autoPayload.find((info) => info.type === 'owners')

    if (ownersObj) {
      obj['owners'] = ownersObj?.values
    }

    return obj
  }

  useEffect(() => {
    if (
      (data?.swimlane_type === undefined || data?.swimlane_type === 'STATIC') &&
      !isEmpty(data.content_data) &&
      data?.content_data[0]?.content_id
    ) {
      contentListCall({
        data: {
          filters: { content_ids: data.content_data.map((card) => card.content_id) },
          page: 1,
          order_by: '',
          reverse: '',
          page_size: data?.content_data?.length,
        },
      })
    } else if (
      data?.swimlane_type === 'DYNAMIC' &&
      (!isEmpty(data.dynamic_data.content_data) || !isEmpty(data.dynamic_data.auto_payload))
    ) {
      let filterPayload =
        data.dynamic_data.type === 'STATIC'
          ? { content_ids: data.dynamic_data.content_data }
          : {
              system_defined: data.dynamic_data.auto_payload.filter(
                (info) => info.type === 'system_defined',
              ),
              custom_defined: data.dynamic_data.auto_payload.filter(
                (info) => info.type === 'custom_defined',
              ),
              video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
              ...getDynamicFilters(data.dynamic_data.auto_payload),
            }

      contentListCall({
        data: {
          filters: filterPayload,
          page: 1,
          order_by:
            data.dynamic_data.type === 'STATIC'
              ? ''
              : data?.dynamic_data.order_by === 'title'
              ? `title.${language}`
              : data?.dynamic_data.order_by,
          reverse: data.dynamic_data.type === 'STATIC' ? '' : data?.dynamic_data.reverse,
          page_size:
            data.dynamic_data.type === 'STATIC' ? data.dynamic_data.content_data?.length : 25,
        },
      })
    } else {
      setContentData([])
    }
  }, [data])

  useEffect(() => {
    if (contentList && contentList.success) {
      if (data?.swimlane_type === 'DYNAMIC' && data?.dynamic_data?.type === 'STATIC') {
        contentList?.data.sort((a, b) => {
          let sortingArr = data.dynamic_data.content_data
          return sortingArr.indexOf(a.content_id) - sortingArr.indexOf(b.content_id)
        })
      }
      // for geo fencing
      let contentIDsMap = [...contentList?.data]?.map((info) => info?.content_id)
      let allContentArr = [...data?.content_data]?.filter((info) =>
        contentIDsMap.includes(info?.content_id),
      )

      setContentMapData([...allContentArr])
      setContentData(contentList.data)
    }
  }, [contentList])

  const handleHover = (index) => {
    if (isEdit) return
    // console.log('contentCardRef.current', contentCardRef.current.classList)
    setHoverCardIndex(index)
  }

  const handleUnHover = () => {
    if (isEdit) return
    setHoverCardIndex('')
  }

  const handleHoverItems = (name) => {
    // if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const checkButtonEnabled = () => {
    if (data?.swimlane_type === 'DYNAMIC') {
      return contentData?.length > visibleSlides
    }

    return contentMapData?.length > visibleSlides
  }

  return (
    <div
      className={`${isEdit && hoverState && 'component-hover-class'} relative py-[16px]`}
      style={{
        backgroundColor: getStyleValue('component_settings', 'component_background', theme.c1),
        zIndex: hoverState ? 2 : 1,
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onEdit={() => handleModal()}
          onDelete={() => onDelete(id)}
          onCopy={() => onCopy(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
        />
      )}

      <CarouselProvider
        naturalSlideWidth={isBrowser ? 200 : 140}
        naturalSlideHeight={isBrowser ? 300 : 210}
        visibleSlides={visibleSlides}
        step={visibleSlides}
        totalSlides={data?.swimlane_type === 'DYNAMIC' ? contentData.length : contentMapData.length}
      >
        <div
          className="flex items-baseline"
          style={{
            padding: '0 3.66032%',
          }}
        >
          <p
            style={{
              color: getStyleValue('component_settings', 'component_heading_text', theme.c3),
              fontFamily: getStyleValue('component_settings', 'font', ''),
              textAlign: isAoSportsComponent
                ? 'left'
                : getStyleValue('heading', 'alignment', 'left'),
              borderColor: isAoSportsComponent
                ? getStyleValue('heading', 'line_color', '#E4022B')
                : '',
            }}
            className={`${
              isAoSportsComponent
                ? 'border-l-4 pl-3 text-[21px] leading-[1.1] flex items-center justify-between mb-3.5'
                : 'xl:text-2xl md:text-xl text-xs mb-0'
            }  w-full ${getStyleValue('heading', 'font_format', 'font-bold')} `}
          >
            {data?.name}
          </p>
        </div>
        <div
          className={`swimlane-container-dock vertical-spotlight-slider-class h-[230px] lg:h-[325px] 2xl:max-h-[380px]  z-10`}
          style={{
            backgroundColor: getStyleValue('component_settings', 'component_background', theme.c1),
          }}
        >
          <Slider
            style={{
              minHeight: hoverCardIndex !== '' && isBrowser ? `23rem` : 'unset',
              maxHeight: '380px',
            }}
            className={`${isAoSportsComponent ? '' : 'pt-2 xl:pt-3'}`}
          >
            {(data?.swimlane_type === 'STATIC' || data?.swimlane_type === undefined) &&
            !isEmpty(contentData) &&
            !isEmpty(contentMapData)
              ? contentMapData.map((item, index) => {
                  return (
                    <Slide key={index} index={index} className="">
                      <div
                        style={{
                          display: hoverCardIndex === index && isBrowser ? 'block' : 'none',
                        }}
                        className="relative"
                        onMouseLeave={handleUnHover}
                      >
                        <NewContentCardHover
                          data={
                            contentData.filter((info) => info.content_id === item?.content_id)
                              .length
                              ? contentData.filter(
                                  (info) => info.content_id === item?.content_id,
                                )[0]
                              : item
                          }
                          type={'content'}
                          position={index + 1}
                          total={contentMapData?.length}
                          visibleSlides={visibleSlides}
                          isVisible={hoverCardIndex === index && isBrowser}
                          top={'-8px'}
                        />
                      </div>
                      <div
                        className="relative"
                        style={{ opacity: hoverCardIndex === index && isBrowser ? 0 : 1 }}
                        onMouseOver={() => handleHover(index)}
                      >
                        <PortraitOwlCard
                          thumbnail={item?.card_thumbnail}
                          data={
                            contentData.filter((info) => info.content_id === item?.content_id)
                              .length
                              ? contentData.filter(
                                  (info) => info.content_id === item?.content_id,
                                )[0]
                              : item
                          }
                          headingColor={getStyleValue(
                            'card_settings',
                            'card_title_heading',
                            '#fff',
                          )}
                          headingClass={'text-xs md:text-sm xl:text-[15px]'}
                          subHeadingClass={'text-[10px]'}
                          subHeadingColor={getStyleValue(
                            'card_settings',
                            'card_title_subheading',
                            '#afafaf',
                          )}
                          gradientColor={getStyleValue(
                            'card_settings',
                            'card_text_background',
                            '#000',
                          )}
                          isEdit={isEdit}
                        />
                      </div>
                    </Slide>
                  )
                })
              : null}
            {data?.swimlane_type === 'DYNAMIC' && !isEmpty(contentData)
              ? contentData.map((item, index) => {
                  return (
                    <Slide key={index} index={index} className="">
                      <div
                        style={{
                          display: hoverCardIndex === index && isBrowser ? 'block' : 'none',
                        }}
                        className="relative"
                        onMouseLeave={handleUnHover}
                      >
                        <NewContentCardHover
                          data={item}
                          type={'content'}
                          position={index + 1}
                          total={contentData?.length}
                          visibleSlides={visibleSlides}
                          isVisible={hoverCardIndex === index && isBrowser}
                          top={'-8px'}
                        />
                      </div>
                      <div
                        className="relative"
                        style={{ opacity: hoverCardIndex === index && isBrowser ? 0 : 1 }}
                        onMouseOver={() => handleHover(index)}
                      >
                        <PortraitOwlCard
                          thumbnail={item?.portrait}
                          data={item}
                          headingColor={getStyleValue(
                            'card_settings',
                            'card_title_heading',
                            '#fff',
                          )}
                          headingClass={'text-xs md:text-sm xl:text-[15px]'}
                          subHeadingClass={'text-[10px]'}
                          subHeadingColor={getStyleValue(
                            'card_settings',
                            'card_title_subheading',
                            '#afafaf',
                          )}
                          gradientColor={getStyleValue(
                            'card_settings',
                            'card_text_background',
                            '#000',
                          )}
                          aspectRatio={'0.7368421053'}
                          isEdit={isEdit}
                        />
                      </div>
                    </Slide>
                  )
                })
              : null}
          </Slider>
          {isBrowser && (
            <>
              {checkButtonEnabled() ? (
                <ButtonBack className="">
                  <div
                    style={{
                      backgroundColor: getStyleValue(
                        'component_background',
                        'primary_color',
                        theme.c1,
                      ),
                    }}
                    className="kalingo-left-arrow-small flex items-center justify-center h-[230px] lg:h-[325px] 2xl:max-h-[380px] "
                  >
                    <img src={KalingoLeftArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
                  </div>
                </ButtonBack>
              ) : null}
              {checkButtonEnabled() ? (
                <ButtonNext className="">
                  <div
                    style={{
                      backgroundColor: getStyleValue(
                        'component_background',
                        'primary_color',
                        theme.c1,
                      ),
                    }}
                    className="kalingo-right-arrow-small flex items-center justify-center h-[230px] lg:h-[325px] 2xl:max-h-[380px] "
                  >
                    <img
                      src={KalingoRightArrow}
                      style={{ height: '37px' }}
                      alt="KalingoLeftArrow"
                    />
                  </div>
                </ButtonNext>
              ) : null}
            </>
          )}
        </div>
      </CarouselProvider>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default withTheme(VerticalSpotlightCards)
